<template>
<w-sliding-popup :type="slidingPopupType" ref="slidingPopup" :title="popupTitle" width="500px" @open="open" @close="close" append-to-body modal-append-to-body>
  <div slot="content">
    <el-row class="title-bar">
      <div class="title-h4">기본 정보</div>
    </el-row>
    <el-form :model="rscFormData" label-position="top" :rules="rules" ref="rscForm">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="자원구분명" prop="rsctypeName">
            <el-input v-model="rscFormData.rsctypeName" placeholder="입력해 주세요." disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="자원 ID" prop="rscId">
            <el-input v-model="rscFormData.rscId" placeholder="입력해 주세요." disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="자원명" prop="rscName">
            <el-input v-model="rscFormData.rscName" placeholder="입력해 주세요." disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="자원단위" prop="rscUnit">
            <el-input v-model="rscFormData.rscUnit" placeholder="입력해 주세요." disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="이벤트 판단타입" prop="eventJudgeConditionTypeId">
            <el-select v-model="rscFormData.eventJudgeConditionTypeId" style="width:100%" :disabled="slidingPopupType != 'setting'">
              <el-option v-for="item in eventJudgeConditionTypeList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="수집방식" prop="rscGetmethodId">
            <el-select v-model="rscFormData.rscGetmethodId" style="width:100%" disabled>
              <el-option v-for="item in rscGetmethodList" :key="item.rscGetmethodId" :label="item.rscGetmethodName" :value="item.rscGetmethodId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="rscFormData.rscGetmethodId !== 'WATCHALL'" class="mr-t25">
        <el-row type="flex" justify="space-between" class="title-bar vertical-center-box">
          <div class="title-h4">수집 설정</div>
          <el-button type="primary" size="mini" @click="clickRscGetdataSettingButton">수집 설정 관리</el-button>
        </el-row>
        <el-form-item label="수집 설정 구분" prop="rscGetdataTypeId">
          <el-select v-model="rscFormData.rscGetdataTypeId" style="width:100%">
            <el-option v-for="item in rscGetdataTypeList" :key="item.rscGetdataTypeId" :label="item.rscGetdataTypeName" :value="item.rscGetdataTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="수집 설정" prop="sourceId">
          <el-select v-model="rscFormData.sourceId" style="width:100%">
            <el-option v-for="item in rscGetdataSourceList" :key="item.sourceId" :label="item.sourceName" :value="item.sourceId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="수집 설정 값" prop="sourceData">
          <el-input v-model="rscFormData.sourceData" type="textarea" :rows="5" placeholder="입력해 주세요." readonly></el-input>
        </el-form-item>
      </div>
    </el-form>
    <w-rsc-getdata-setting-popup ref="rscGetdataSettingPopup" :rsc-getmethod-id="rscFormData.rscGetmethodId" :sliding-popup-type="slidingPopupType" @reload-rsc-get-method-data="reloadRscGetMethodData"/>
  </div>
  <div slot="footer" v-show="(slidingPopupType == 'setting') || (slidingPopupType != 'setting' && rscFormData.rscGetmethodId != 'WATCHALL')">
    <div>
      <el-button size="large" type="solid" class="mr-r4" @click="saveButton" :disabled="slidingPopupType != 'setting' && rscFormData.rscGetmethodId == 'WATCHALL'">저장</el-button>
      <el-button size="large" @click="cancelButton">취소</el-button>
    </div>
  </div>
</w-sliding-popup>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import RscSettingsAPI from '@/api/settings/common/rsc-settings';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import BasicinfoSetAPI from '@/api/model/basicinfo-sub';
import RscAPI from '@/api/model/rsc';
import WRscGetdataSettingPopup from './RscGetdataSettingPopup';

export default {
  name: 'WUpdateRscPopup',
  props: {
    slidingPopupType: String,
    objInfo: Object,
    updateRow: Object,
    managetypeId: String,
    managetypeKey: String,
    selectedRule: Object,
  },
  components: {
    WRscGetdataSettingPopup,
  },
  watch: {
    'rscFormData.rscGetdataTypeId': {
      handler(value) {
        if (!isNil(value)) {
          RscAPI.getRscGetdataSourceList(this.rscFormData.rscGetmethodId, value).then((response) => {
            const result = cloneDeep(response.data.data);
            if (!isNil(result)) {
              this.rscGetdataSourceList = result;
              if (isNil(this.rscFormData.sourceId)) {
                this.rscFormData.sourceId = result[0].sourceId;
              } else {
                const sourceIndex = result.findIndex((object) => object.sourceId === this.rscFormData.sourceId);
                if (sourceIndex < 0) {
                  this.rscFormData.sourceId = result[0].sourceId;
                } else {
                  this.rscFormData.sourceData = result[sourceIndex].sourceData;
                }
              }
            }
          });
        }
      },
    },
    'rscFormData.sourceId': {
      handler(value) {
        if (!isNil(value)) {
          const rscGetdataSourceList = this.rscGetdataSourceList;
          if (rscGetdataSourceList.length > 0) {
            const rscGetmethodId = this.rscFormData.rscGetmethodId;
            const rscGetdataTypeId = this.rscFormData.rscGetdataTypeId;
            const sourceObject = rscGetdataSourceList.find((object) => object.rscGetmethodId === rscGetmethodId && object.rscGetdataTypeId === rscGetdataTypeId && object.sourceId === value);
            if (!isNil(sourceObject)) {
              this.rscFormData.sourceData = sourceObject.sourceData;
            }
          }
        }
      },
    },
  },
  data() {
    return {
      popupTitle: null,
      rscGetmethodList: [],
      eventJudgeConditionTypeList: [],
      rscGetdataTypeList: [],
      rscGetdataSourceList: [],
      rscFormData: {
        rscGetdataTypeId: null,
        sourceId: null,
        sourceData: null,
        eventJudgeConditionTypeId: null,
      },
      rules: {
        eventJudgeConditionTypeId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        rscGetdataTypeId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
        sourceId: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  methods: {
    open() {
      this.popupTitle = `[${this.updateRow.rscName}] 수집/판단 정보`;
      Object.assign(this.rscFormData, this.updateRow);
      const managetypeId = this.managetypeId;
      RscSettingsAPI.getRscGetmethodList({
        managetypeId,
      }).then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.rscGetmethodList = cloneDeep(result);
        }
      });
      BasicinfoSetAPI.getList('EVENT_JUDGE_TYPE').then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventJudgeConditionTypeList = cloneDeep(result);
        }
      });
      if (this.rscFormData.rscGetmethodId !== 'WATCHALL') {
        RscAPI.getRscGetdataTypeList(this.rscFormData.rscGetmethodId).then((response) => {
          const result = cloneDeep(response.data.data);
          if (!isNil(result)) {
            this.rscGetdataTypeList = result;
            if (isNil(this.rscFormData.rscGetdataTypeId)) {
              this.rscFormData.rscGetdataTypeId = result[0].rscGetdataTypeId;
            }
          }
        });
      }
    },
    close() {
      // this.rscGetdataSettingShowFlag = false;
      // this.$refs.rscForm.resetFields();
      // this.rscFormData = {
      //   rscGetdataTypeId: null,
      //   sourceId: null,
      //   sourceData: null,
      // };
    },
    saveButton() {
      if (isEqual(this.slidingPopupType, 'setting')) {
        const rscFormData = this.rscFormData;
        this.$refs.rscForm
          .validate()
          .then((response) => {
            if (response) {
              RuleSettingsAPI.updateRuleRscInfo(rscFormData).then(() => {
                this.$emit('re-load');
                this.cancelButton();
              });
            }
          })
          .catch(() => {});
      } else {
        const rscFormData = this.rscFormData;
        rscFormData.objId = this.objInfo.obj.objId;
        this.$refs.rscForm
          .validate()
          .then((response) => {
            if (response) {
              RuleSettingsAPI.updateIndividualRuleInfo(rscFormData).then(() => {
                this.$emit('re-load');
                this.cancelButton();
              });
            }
          })
          .catch(() => {});
      }
    },
    cancelButton() {
      this.$refs.slidingPopup.visible = false;
    },
    clickRscGetdataSettingButton() {
      this.$refs.rscGetdataSettingPopup.open();
    },
    reloadRscGetMethodData() {
      this.rscFormData.rscGetdataTypeId = null;
      if (this.rscFormData.rscGetmethodId !== 'WATCHALL') {
        RscAPI.getRscGetdataTypeList(this.rscFormData.rscGetmethodId).then((response) => {
          const result = cloneDeep(response.data.data);
          if (!isNil(result)) {
            this.rscGetdataTypeList = result;
            if (isNil(this.rscFormData.rscGetdataTypeId)) {
              this.rscFormData.rscGetdataTypeId = result[0].rscGetdataTypeId;
            }
          }
        });
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/popup/UpdateRuleRscPopup.vue